// extracted by mini-css-extract-plugin
module.exports = {"balance_button":"BalanceVideoButton_balance_button__3T8QJ","align":"BalanceVideoButton_align__yzgVK","button_plus":"BalanceVideoButton_button_plus__1CIt5"};